import { render, staticRenderFns } from "./ValidNotificaciones.vue?vue&type=template&id=ba8785ce&scoped=true"
import script from "./ValidNotificaciones.vue?vue&type=script&lang=js"
export * from "./ValidNotificaciones.vue?vue&type=script&lang=js"
import style0 from "./ValidNotificaciones.vue?vue&type=style&index=0&id=ba8785ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8785ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8785ce')) {
      api.createRecord('ba8785ce', component.options)
    } else {
      api.reload('ba8785ce', component.options)
    }
    module.hot.accept("./ValidNotificaciones.vue?vue&type=template&id=ba8785ce&scoped=true", function () {
      api.rerender('ba8785ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/ValidNotificaciones.vue"
export default component.exports